import React from 'react';
import { Card, CardContent } from './ui/card';
import { Plus, Upload, Calendar, ShoppingCart } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import '@/design-system/typography.css';
import '@/design-system/forms.css';
import { colors } from '@/design-system/colors';

interface QuickAccessItem {
  title: string;
  icon: React.ReactNode;
  onClick: () => void;
}

export function QuickAccess() {
  const navigate = useNavigate();

  const quickAccessItems: QuickAccessItem[] = [
    {
      title: 'New Purchase Order',
      icon: <Plus className="h-4 w-4" />,
      onClick: () => navigate('/cost-management/purchase-orders', { state: { openForm: true } }),
    },
    {
      title: 'New Daily Log',
      icon: <Plus className="h-4 w-4" />,
      onClick: () => navigate('/project-management/daily-logs', { state: { openForm: true } }),
    },
    {
      title: 'New To-Do',
      icon: <Plus className="h-4 w-4" />,
      onClick: () => navigate('/project-management/todos', { state: { openForm: true } }),
    },
    {
      title: 'Upload Document',
      icon: <Upload className="h-4 w-4" />,
      onClick: () => navigate('/drive'),
    },
    {
      title: 'View Schedule',
      icon: <Calendar className="h-4 w-4" />,
      onClick: () => navigate('/project-management/schedule'),
    },
  ];

  return (
    <Card>
      <CardContent className="p-4">
        <h2 className="font-section-subheader mb-3">Quick Access</h2>
        <div className="space-y-2">
          {quickAccessItems.map((item, index) => (
            <button
              key={index}
              onClick={item.onClick}
              className="flex items-center space-x-2 w-full p-2 font-dashboard-text font-semibold text-gray-700 hover:bg-gray-50 rounded-lg transition-colors border"
              style={{ borderColor: colors.tableBorder }}
            >
              {item.icon}
              <span>{item.title}</span>
            </button>
          ))}
        </div>
      </CardContent>
    </Card>
  );
} 